import { Component, OnInit } from "@angular/core"
import { PremiumResourcePageLinkOption } from "../../../models/collection/premiumResourcePageLinkOption.model"
import { PremiumCollectionOfResource } from "../../../models/collection/premiumCollectionOfResource.model"
import { Resource } from "../../../models/resource/resource"
import { ResourceService } from "../../../services/resource.service"
import { EduComponent } from "../../../utils/eduComponent"
import { UserService } from "../../../services/user.service"
import { ModalService } from "../../../shared-components/modal/modal.service"
import { AuthModalComponent } from "../../../shared-components/modals/auth-modal/auth-modal.component"
import { AddOnViewService } from "../../../services/add-on-view.service"
import { Observable } from "rxjs"
import { PreviewService } from "../../../services/preview.service"
import moment from "moment/moment"

@Component({
    selector: "app-resource-subtitle",
    templateUrl: "./resource-subtitle.component.html",
    styleUrls: ["./resource-subtitle.component.scss"],
    standalone: false,
})
export class ResourcesSubtitleComponent extends EduComponent implements OnInit {
    title: string = null
    mediaTypeTitle: string = ""
    mediaTypeClass: string = ""
    gradesDisplay = null
    collection: any = null
    contentProject: any = {}
    primaryCollection: PremiumCollectionOfResource
    collections: PremiumCollectionOfResource[]
    linksOptions: PremiumResourcePageLinkOption[]
    isAvailableToStudents: boolean = true
    favoriteId: string
    isAddonView: boolean
    isTeacherPreview: boolean = true
    resource: Resource = new Resource()
    resourceExpirationDate: string = ""
    isInPreviewMode$: Observable<boolean>

    constructor(
        public resourceService: ResourceService,
        public userService: UserService,
        private modalService: ModalService,
        private addOnService: AddOnViewService,
        private previewService: PreviewService
    ) {
        super()
    }

    public ngOnInit() {
        this.isInPreviewMode$ = this.previewService.previewOnResource$
        this.isAddonView = this.addOnService.isAddonView
        this.isTeacherPreview = this.addOnService.isTeacherPreview
        this.addSub(
            this.resourceService.resourceResponse.subscribe((resource: Resource) => {
                this.favoriteId = resource.favoriteId
                this.title = resource.title
                this.resourceExpirationDate = resource.expirationDate
                this.gradesDisplay = resource.gradesDisplay
                this.mediaTypeTitle = resource.getMediaTypeTitle()
                this.mediaTypeClass = (this.mediaTypeTitle || "").replace(/\s/g, "")
                this.contentProject = resource.project
                this.primaryCollection = this.resolvePrimaryCollection(resource)
                this.isAvailableToStudents = resource.isAvailableToStudents

                this.collections = resource.collection.collections.filter(
                    (collection) => collection.title !== this.primaryCollection.title
                )

                this.linksOptions = this.collections.map((obj) =>
                    PremiumResourcePageLinkOption.fromData(obj)
                )
            })
        )
    }

    public teacherLogin() {
        this.resourceService.switchResourceView()
        this.modalService.open(AuthModalComponent)
    }

    get resourceExpiresInNext18Months(): boolean {
        if (!this.resourceExpirationDate || this.userService.hasStudentExperience()) return false
        const endDate: Date = new Date(this.resourceExpirationDate)
        return moment(new Date(endDate)).diff(new Date(), "months", true) <= 18
    }

    private resolvePrimaryCollection(resource: Resource): PremiumCollectionOfResource {
        if (!resource.collection.firstCollection && !resource.collection.collections.length) {
            return
        }

        return PremiumCollectionOfResource.fromData(
            resource.collection.firstCollection
                ? resource.collection.firstCollection
                : {
                      // TODO: refactor API to get consistent objects
                      canonical_url: resource.collection.collections[0]["canonical_url"]
                          ? resource.collection.collections[0]["canonical_url"]
                          : resource.collection.collections[0].path,
                      title: resource.collection.collections[0].title,
                  }
        )
    }
}
